import request from '@/service/request';

export const getAgencyInfo = () => {
  return request.get('/v1/agency-platform-vn-v2/agency/user_info');
};

export const getDownlines = (data: any) => {
  return request.get(`/v1/agency-platform-vn-v2/agency/downLines`, {
    params: data,
  });
};

export const verifyPaymentPassword = (data: any) => {
  return request.post(
    '/v1/agency-platform-vn-v2/agency/user_info/payment_password',
    { data },
  );
};

export const bindBankAccount = (data: any) => {
  return request.post('/v1/agency-platform-vn-v2/agency/bank_account', {
    data,
  });
};

export const getAccounts = () => {
  return request.get('/v1/agency-platform-vn-v2/agency/bank_accounts');
};

export const resetPassword = (data: { email: string }) => {
  return request.post(`${ADMIN_PREFIX}/login/forget`, { data });
};

export const changePassword = (data: {
  email: string;
  old_password: string;
  new_password: string;
}) => {
  return request.post(`/v2/admin_account/account/reset-password`, { data });
};

export const setPaymentPassword = (data: {
  payment_password: string;
  old_payment_password?: string;
}) => {
  return request.put(
    '/v1/agency-platform-vn-v2/agency/user_info/payment_password',
    {
      data,
    },
  );
};

export const getStatistics = (data: any) => {
  return request.get('/v1/agency-platform-vn-v2/agency/statistics', {
    params: data,
  });
};

export const sendEmailOtp = (params: any) => {
  return request.post(`/v1/admin_account/login/email_verification/send_code`, {
    data: params,
  });
};

export const sendPhoneOtp = (params: any) => {
  return request.post(`/v1/admin_account/login/phone_verification/send_code`, {
    data: params,
  });
};

export const verifyEmailOtp = (params: any) => {
  return request.post(`/v1/admin_account/login/email_verification/check_code`, {
    data: params,
  });
};

export const verifyPhoneOtp = (params: any) => {
  return request.post(`/v1/admin_account/login/phone_verification/check_code`, {
    data: params,
  });
};

export const resetPaymentPassword = (params: any) => {
  return request.post(
    '/v1/agency-platform-vn-v2/agency/user_info/payment_password/reset',
    {
      data: params,
    },
  );
};
